import { AccessGuids, ConfigSystemParams, FieldAliases } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardUsersWithMostCostDTO } from 'src/app/core/models/system/dashboard/dashboard-users-with-most-cost.dto';
import { EncryptAesClientSide } from 'src/app/core/encryption';
import { eUser } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { Router } from '@angular/router';
import { SimStatusDisplay, SimStatusDisplay_EmptyObject } from 'src/app/core/interfaces/general/sim-status-display';
import { SimStatusService } from 'src/app/core/services/utelize/general/sim-status-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TimelineEsimModalFormComponent } from 'src/app/forms-modal/_time-line/timeline-esim-modal-form/timeline-esim-modal-form.component';
import { UserModalFormComponent } from 'src/app/forms-modal/_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';

@Component({
  selector: 'app-users-most-cost',
  templateUrl: './users-most-cost.component.html',
  styleUrls: ['./users-most-cost.component.scss']
})
export class UsersMostCostComponent implements OnInit {
  
  @ViewChild('companyModalForm',    { static: false }) companyModalForm!   : CompanyModalFormComponent;
  @ViewChild('manageEsimModalForm', { static: false }) manageEsimModalForm!: ManageEsimModalFormComponent;
  @ViewChild('timelineModalForm',   { static: false }) timelineModalForm!  : TimelineEsimModalFormComponent;
  @ViewChild('userModalForm',       { static: false }) userModalForm!      : UserModalFormComponent;
  
  @Input() userWithMostCost: DashboardUsersWithMostCostDTO[] | undefined;
  @Input() loading         : boolean=true;

  @Output() refreshData    : EventEmitter<void>=new EventEmitter<void>();

  get fieldAliasUsername() { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasUsername, FieldAliases.FieldAliasUsername); }
  
  get blueGridLinks         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardGridLinksInBlue,               true ); }
  get centreCost            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardTopUsersMostCostCentreCost,    false); }
  get centreUsageMb         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardTopUsersMostCostCentreUsageMb, false); }
  get showFullnameAsUsername() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowFullnameAsUsername,                 true ); }
  get showTag               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardTopUsersShowTag,               false) &&
                                        this.componentAccessUserService.hasAccessGuid(AccessGuids.DashboardTopUsersShowTag,                   true ); }
  get showTag2              () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardTopUsersShowTag2,              false) &&
                                        this.componentAccessUserService.hasAccessGuid(AccessGuids.DashboardTopUsersShowTag2,                  true ); }
  get showTimelineAsModal   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTimelineAsModal,                    false); }
  get showTooltips          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                           false); }
  
  private companyModalFormIsOpen: boolean=false;
  private manageEsimFormIsOpen  : boolean=false;
  private userModalFormIsOpen   : boolean=false;

  public curUser: SystemUserDTO;

  constructor(
    private authenticationService     : AuthenticationService,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService,
    private ordersService             : OrdersService,
    private router                    : Router,
    private simStatusService          : SimStatusService,
    private usersService              : UsersService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  ngOnInit(): void { }

  //#region Mouse Events - not used at present

  public mouseEnter() {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public mouseLeave() {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Company

  public companyClick(companyName: string) {
    try {
      if (!this.companyModalFormIsOpen) {
        this.companyModalFormIsOpen=true;
        
        this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.companyModalForm.openForm(data.result);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormHasBeenCancelled() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ICCID

  public getSimStatus(row: any): SimStatusDisplay {
    try {
      return this.simStatusService.getDisplayForRow(row);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SimStatusDisplay_EmptyObject();
    }
  }

  public iccidClick(iccid: string) {
    try {
      if (!this.manageEsimFormIsOpen) {
        this.manageEsimFormIsOpen=true;
        
        this.ordersService.getOrderIdByIccid(iccid)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.manageEsimModalForm.openForm(data.result);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public orderDataHasBeenSaved() {
    try {
      this.manageEsimFormIsOpen=false;
      this.refreshData.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public orderStatusHasBeenUpdated() {
    try {
      this.refreshData.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public manageEsimFormHasBeenCancelled() {
    try {
      this.manageEsimFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#region User

  public userClick(companyName: string, userName: string) {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        
        this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            const companyId: number=data.result;

            this.usersService.getIdByUsername(companyId, userName)
            .pipe(
              catchError((error) => {
                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
              })
            )
            .subscribe({
              next: data => {
                this.userModalForm.openForm(data.result, eUser.sim);
              },
              error: error => {
                this.exceptionsService.handleException(new Error(error));
              }
            });
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public viewTimeline(iccid: string) {
    try {
      if (this.showTimelineAsModal) {
        this.timelineModalForm.openForm(iccid);
        
      } else {
        this.router.navigate(["/timeline/esim-timeline", EncryptAesClientSide(iccid)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
